export default __webpack_public_path__ + "static/media/cir-quiz-btn.e1e9957b.svg";